import CoreMessageDispatcher from '../controller/CoreMessageDispatcher';
import ChangeOrders from '../events/ChangeOrders';
import CoreEvents from '../events/CoreEvents';
const Swiper = require('swiper').default;
const SizesUtils = require('../../../../viscomjs/utils/SizesUtils');

const _dispatcher = CoreMessageDispatcher.instance();

//
// Lifecycle functions
//
const _start = mdr => {
    if (mdr.started) return mdr;

    _initSwiper(mdr);
    _addCoreListeners(mdr, true);

    mdr._to = setTimeout(() => {
        _initSlides(mdr);

        _dispatcher.emit(ChangeOrders.INITIATE_STATES, {states: mdr.slidesUniqeIds});

        _updateCurrentState(mdr, _getCurrentSwiperState(mdr));
        _forceSwiperSwitchOn(mdr);
        _updateSwiperState(mdr);
        mdr.ready = true;
        //
    }, 100);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    if (mdr._to) {
        clearTimeout(mdr._to);
        delete mdr._to;
    }

    _addCoreListeners(mdr, false);
    _destroySwiper(mdr);

    mdr.started = false;
    return mdr;
};

const _externalUpdateState = mdr => {
    const newId = mdr.model.state;
    if (newId !== mdr.state.currentId) {
        mdr.state.newId = newId;
        mdr.state.newIdChanged = true;
    }

    _updateSwiperState(mdr);
    mdr.state.newIdChanged = false;
};

const _internalUpdate = mdr => {
    const newState = _getCurrentSwiperState(mdr);

    _updateCurrentState(mdr, newState);

    if (mdr.state.currentIdChanged) {
        _dispatcher.emit(ChangeOrders.SWIPE_TO_STATE, mdr.state.currentId);
    }

    mdr.state.currentIdChanged = false;
    mdr.state.currentIndexChanged = false;
};

const _updateCurrentState = (mdr, newState) => {
    if (!newState) return;
    mdr.state.currentIdChanged = newState.id !== mdr.state.currentId;
    mdr.state.currentIndexChanged = newState.index !== mdr.state.currentIndex;
    mdr.state.currentId = newState.id;
    mdr.state.currentIndex = newState.index;

    _updateSwiperState(mdr);
};

//

//
// Swiper
//
const _initSwiper = mdr => {
    const w = SizesUtils.winWidth();
    const h = SizesUtils.winHeight();
    const direction = h > w || (w <= 425 || h <= 425) || (w > 425 && w <= 768 && h > 425 && h < w) ? 'vertical' : 'horizontal';

    mdr._sw = new Swiper(mdr.el, {
        direction: direction,
        effect: 'fade',
        speed: 400,
        loop: true,
        nested: true,
        spaceBetween: 0,
        snapOnRelease: true,
        transforms3d: true,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        touchEventsTarget: 'container',
        followFinger: false,
        // forceToAxis: true,
        fadeEffect: {
            crossFade: true
        },
        mousewheel: {
            enabled: true
        },
        keyboard: {
            enabled: true
        }
    });

    mdr._sw.on('realIndexChange', mdr.internalUpdate);
};

const _destroySwiper = mdr => {
    mdr._sw.destroy();
    mdr._sw = null;
};

const _forceSwiperSwitchOn = mdr => {
    mdr._sw.mouseEntered = true;
};

const _initSlides = mdr => {
    mdr.slides = [...mdr.el.querySelectorAll('.swiper-slide')];

    mdr.slidesIndices = mdr.slides.map(el => parseInt(el.dataset.swiperSlideIndex));
    mdr.slidesIds = mdr.slides.map(el => el.dataset.sectionId);

    mdr.slidesUniqeIds = mdr.slides.filter(el => !el.classList.contains('swiper-slide-duplicate')).map(el => el.dataset.sectionId);
    mdr.numSlides = mdr.slidesUniqeIds.length;
};

const _getCurrentSwiperState = mdr => {
    if (!mdr.slides || mdr.slides.length < 1) return null;
    return {id: mdr.slidesIds[mdr._sw.activeIndex], index: mdr.slidesIndices[mdr._sw.activeIndex]};
};

const _getActiveIndexById = (mdr, id) => {
    return mdr.slidesIds.findIndex(slideId => slideId === id);
};

const _updateSwiperState = mdr => {
    if (mdr.state.newIdChanged) {
        const newIndex = _getActiveIndexById(mdr, mdr.state.newId);
        if (newIndex > -1 && newIndex < mdr.slides.length - 1) {
            mdr._sw.allowSlidePrev = true;
            mdr._sw.allowSlideNext = true;
            mdr._sw.allowTouchMove = true;

            mdr._sw.slideTo(newIndex, 0);
        }
    }

    mdr._sw.allowSlidePrev = mdr.model.allowGetPrevState;
    mdr._sw.allowSlideNext = mdr.model.allowGetNextState;
    mdr._sw.allowTouchMove = mdr.model.navAllowed;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.MODEL_CHANGED, mdr.externalUpdateState);
        _dispatcher.on(CoreEvents.MODEL_STATE_CHANGED, mdr.externalUpdateState);
        _dispatcher.on(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr.externalUpdateState);
        _dispatcher.on(CoreEvents.TRANSITION_STATE_CHANGED, mdr.externalUpdateState);
        return;
    }

    _dispatcher.off(CoreEvents.MODEL_CHANGED, mdr.externalUpdateState);
    _dispatcher.off(CoreEvents.MODEL_STATE_CHANGED, mdr.externalUpdateState);
    _dispatcher.off(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr.externalUpdateState);
    _dispatcher.off(CoreEvents.TRANSITION_STATE_CHANGED, mdr.externalUpdateState);
};

//

//
// Constructor
//
const CoreSwiperMediator = (el, model) => {
    const mdr = {
        el: el,
        model: model,
        state: {}
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    mdr.internalUpdate = () => {
        return _internalUpdate(mdr);
    };

    mdr.externalUpdateState = () => {
        return _externalUpdateState(mdr);
    };

    return mdr;
};

export {CoreSwiperMediator};
export default CoreSwiperMediator;
